import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  CanActivate,
  CanActivateChild
} from "@angular/router";
import { Observable } from "rxjs";
import { IsAuthenticatedGuard } from "./is-authenticated.guard";

@Injectable({
  providedIn: "root"
})
export class IsNotAuthenticatedGuard extends IsAuthenticatedGuard implements CanActivate, CanActivateChild {

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean | UrlTree> | boolean {
    return !this._canActivate(route, state);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean | UrlTree> | boolean {
    return !this._canActivate(route, state);
  }

}
